import React from 'react'
import styled from '@emotion/styled'
import { colors } from 'Constants'

import DatePicker from 'react-date-picker'

/* Params:
  - Background
  - Font color
  - Input Color
  - Text Color
 */
const DateContainer = styled.div`
  z-index: 5;
  background: ${({ background }) => background || colors.secondary};
  padding: 0.5em;
  color: ${({ color }) => color || colors.textOnPrimary};

  input,
  button {
    font: inherit;
  }
  input {
    color: ${({ input }) => input || colors.textOnPrimary};
  }

  abbr {
    color: ${({ text }) => text || colors.text};
  }

  header {
    background-color: rgb(50, 54, 57);
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.5);
    padding: 20px;
    color: white;

    h1 {
      font-size: inherit;
      margin: 0;
    }
  }

  &__container {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: flex-start;
    margin: 10px 0;
    padding: 10px;

    & > * {
      & > * {
        margin: 10px;
      }
    }

    &__content {
      display: flex;
      max-width: 100%;
      flex-basis: 420px;
      flex-direction: column;
      flex-grow: 100;
      align-items: stretch;
    }
  }

  .react-date-picker__wrapper {
    border: none;
  }

  .react-date-picker__button:enabled:hover .react-date-picker__button__icon,
  .react-date-picker__button:enabled:focus .react-date-picker__button__icon {
    stroke: ${({ hover }) => hover || colors.textOnPrimary};
  }
`
export const FancyDatePicker = ({ onChange, date }) => {
  return (
    <DateContainer
      background={colors.secondary}
      color={colors.textOnPrimary}
      input={colors.textOnPrimary}
      text={colors.text}
    >
      <DatePicker onChange={onChange} value={date} />
    </DateContainer>
  )
}

export const DatePickerNormal = ({ onChange, date, minDate = undefined, maxDate = new Date() }) => {
  return (
    <DateContainer background="#fff" color="#000" input="#000" text="#000" hover={colors.blue}>
      <DatePicker onChange={onChange} value={date} minDate={minDate} maxDate={maxDate} />
    </DateContainer>
  )
}
